<template>
  <div>
    <div class="control-group col-lg-12">
      <label class="control-label" for="Telefone">Endereço:</label>
    </div>

    <div  class="control-group col-lg-6">
      <label class="control-label">CEP *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.zipcode" class="form-control" />
      </div>
    </div>

    <div class="control-group col-lg-6">
      <label class="control-label">Estado *</label>
      <select v-model="address.state" id="state" class="form-control">
        <option disabled value>Escolha um estado</option>
        <option v-for="s in stateList" v-bind:key="s.key" v-bind:value="s.key">{{s.value}}</option>
      </select>
    </div>

    <div class="control-group col-lg-6">
      <label class="control-label">Cidade *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.city" class="form-control" />
      </div>
    </div>

    <div  class="control-group col-lg-6">
      <label class="control-label">Bairro *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.neighborhood" class="form-control" />
      </div>
    </div>

    <div class="control-group col-lg-12">
      <label class="control-label">Rua *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.street" class="form-control" />
      </div>
    </div>

    <div class="control-group col-lg-6">
      <label class="control-label">Número *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.number" class="form-control" />
      </div>
    </div>

    <div class="control-group col-lg-6">
      <label class="control-label">Complemento *</label>
      <div class="controls">
        <input type="text" maxlength="255" v-model="address.complement" class="form-control" />
      </div>
    </div>
  </div>
</template>


<script>
import { required, minLength } from "vuelidate/lib/validators";
import axios from "axios";
let config = require("../../const.json");
axios.defaults.withCredentials = true;

export default {
  props: ["address"],
  data() {
    return {
      stateList: config.user.state
    };
  },
  validations: {
    
  },
  components: {},
  methods: {
   
  },
  created() {}
};
</script>
